import { collectImageComponentParams, collectVideoUrl } from '../collector';

import { MediaElementProps, MediaSourceStrapiComponent } from './types';

export const collectMediaElementParams = (
  media?: MediaSourceStrapiComponent | null
): MediaElementProps | undefined => {
  if (!media) {
    return undefined;
  }

  const image = collectImageComponentParams(media.media);
  if (image) {
    const legacyStyles = media.legacyStyles ?? true;
    return { image, legacyStyles };
  }

  const video = collectVideoUrl(media?.media);

  if (video) {
    return {
      controls: media?.videoControl,
      video: video,
    };
  }

  if (media.youtubeEmbedId) {
    return {
      youtubeEmbedId: media.youtubeEmbedId,
    };
  }

  return undefined;
};
